import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
const CarouselItem = React.forwardRef(({ className, selected, previous, next, children, style }) => {
    const slideClassList = classNames("slide", className, {
        selected,
        previous,
        next,
    });
    return (_jsx("li", { className: slideClassList, style: style, children: children }));
});
CarouselItem.defaultProps = {
    className: "",
};
export default CarouselItem;
